import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_BEGIN,
  REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_SUCCESS,
  REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_FAILURE,
  REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_DISMISS_ERROR,
} from './constants';

export function exportSummaryDataBySite(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/exportSalesSummaryInSite`, args);
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_FAILURE,
            data: { error: errorMsg },
          });
          reject(errorMsg);
        },
      );
    });

    return promise;
  };
}

export function dismissExportSummaryDataBySiteError() {
  return {
    type: REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_DISMISS_ERROR,
  };
}

export function useExportSummaryDataBySite() {
  const dispatch = useDispatch();

  const { exportSummaryDataBySitePending, exportSummaryDataBySiteError } = useSelector(
    state => ({
      exportSummaryDataBySitePending: state.reports.exportSummaryDataBySitePending,
      exportSummaryDataBySiteError: state.reports.exportSummaryDataBySiteError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportSummaryDataBySite(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportSummaryDataBySiteError());
  }, [dispatch]);

  return {
    exportSummaryDataBySite: boundAction,
    exportSummaryDataBySitePending,
    exportSummaryDataBySiteError,
    dismissExportSummaryDataBySiteError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportSummaryDataBySitePending: true,
        exportSummaryDataBySiteError: null,
      };

    case REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_SUCCESS:
      // The request is success
      return {
        ...state,
        exportSummaryDataBySitePending: false,
        exportSummaryDataBySiteError: null,
      };

    case REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_FAILURE:
      // The request is failed
      return {
        ...state,
        exportSummaryDataBySitePending: false,
        exportSummaryDataBySiteError: action.data.error,
      };

    case REPORTS_EXPORT_SUMMARY_DATA_BY_SITE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportSummaryDataBySiteError: null,
      };

    default:
      return state;
  }
}
